import React from 'react';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';

const BlogsSidebarBreadcrumb = () => {
    return (
        <>
            <Breadcrumb title="Blog" subTitle="Sidebar" smText='Blog Sidebar'></Breadcrumb>
        </>
    );
};

export default BlogsSidebarBreadcrumb;